import axios from 'axios'
import {message} from 'antd'
import {CloseCircleFilled, CloseOutlined} from '@ant-design/icons'
import {isObject} from 'lodash'

import {
  BASE_URL,
  CONTENT_TYPE,
  JSON_POST,
  LOGOUT_EVENT_NAME,
  START_LOADING_EVENT_NAME,
  STOP_LOADING_EVENT_NAME,
} from '@/constants'
import eventBus from '@/common/EventBus';
import {getToken} from '@/common';

const HTTP_ERROR_MESSAGE_KEY = 'http-error-message'

const getErrorMessageLines = errorMessage => String(errorMessage)
  .split(/(?=There (?:are|is) \d+ left of |Please adjust your cart\.)/i)
  .map(line => line.trim())
  .filter(Boolean)

const instance = axios.create({
    baseURL: BASE_URL,
})
instance.defaults.headers.post[CONTENT_TYPE] = JSON_POST;
instance.defaults.withCredentials = false; // 携带cookie
instance.defaults.timeout = 1000*60*5; // 默认请求超时毫秒

//请求拦截器
instance.interceptors.request
  .use(config => {
      const token = getToken()
      eventBus.dispatchEvent(START_LOADING_EVENT_NAME)
      if (token) {
        config.headers.Authorization = `JWT ${token}`
        config.headers.ViewableStores = `usa`
      }
      return config
    }, 
      error => {
        eventBus.dispatchEvent(STOP_LOADING_EVENT_NAME)
        Promise.reject(error)
      }
);
// 响应拦截器
instance.interceptors.response
  .use(response => {
      eventBus.dispatchEvent(STOP_LOADING_EVENT_NAME)
      return response
    },
      error => {
        eventBus.dispatchEvent(STOP_LOADING_EVENT_NAME)
        if (error.response && error.response.status === 401) {
          eventBus.dispatchEvent(LOGOUT_EVENT_NAME)
        }
        let errData = error.response?.data || {}
        if (typeof errData === 'string') {
          errData = {message: errData}
        }
        if (isObject(errData)) {
          const key = Object.keys(errData)[0]
          if (key && Array.isArray(errData[key])) {
            errData.message = `${key}: ${errData[key]}`
          }
        }
        const {message: resMessage} = errData
        if (resMessage) {
          const messageLines = getErrorMessageLines(resMessage)
          errData.isGlobalErrorMessageShown = true
          message.open({
            key: HTTP_ERROR_MESSAGE_KEY,
            duration: 10,
            content: (
              <span style={{display: 'inline-flex', alignItems: 'flex-start', gap: 16}}>
                <CloseCircleFilled
                  style={{color: '#ff4d4f', flexShrink: 0, marginTop: 2}}
                />
                <span style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
                  {messageLines.map((line, index) => <span key={index}>{line}</span>)}
                </span>
                <CloseOutlined
                  style={{cursor: 'pointer', marginTop: 2}}
                  onClick={() => message.destroy(HTTP_ERROR_MESSAGE_KEY)}
                />
              </span>
            ),
          })
        }
        return Promise.reject(errData)
      }
);

export default instance
